export const logo = [];
